import React from 'react'
import './Whatsapp.css'

const Whatsapp = () => {
    return (
        <div>
            <a style={{ marginLeft: "30px", }} href="https://wa.me/+919980411999" class="btn-whatsapp-pulse" target='_blank'>
                <i class="fab fa-whatsapp"></i>
            </a>
        </div>

    )
}

export default Whatsapp